<div class="toastWrapper">
  <div [@slideInOut] *ngFor="let toast of toasts" class="toastWrapper__toast" [ngClass]="getClass(toast)">
    <div>
      <sb-icon class="icon" [icon]="getIcon(toast)"></sb-icon>
      <span class="text" [innerHTML]="toast.message"></span>
    </div>
    <sb-icon class="removeToastButton" (click)="removeToast(toast)" icon="cancel"></sb-icon>
    <!--    <div #progressbar class="toastWrapper__toast__progressbar" [style.width.%]="toast.progress"></div>-->
  </div>
</div>

